module.exports = __webpack_public_path__ + "img/icons8-nissan.4bd7d805.svg";